export default function inView() {
    const options = {
        root: null, // Observe viewport
        rootMargin: '0px',
        threshold: 0.25, // Consider element in view when 50% visible
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const element = entry.target;
            const isInView = entry.isIntersecting;

            if (isInView) {
                element.classList.add('inView'); // Add inView class when in view
            } else {
                element.classList.remove('inView'); // Remove inView class when out of view
            }
        });
    }, options);

    // Add elements with `data-animate-to` or `data-animate-children-to` attributes to observer
    document.querySelectorAll('[data-animate-to], [data-animate-children-to], [class*=animate-children], [class*=animate], .js-check-inview').forEach(el => observer.observe(el));
}
